namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_widget_float_drawing, {

		'[mol_view_error]': {
			Promise: {
				animationName: 'none',
				background: {
					color: 'transparent',
				},
			},
			$mol_promise_blocker: {
				animationName: 'none',
				background: {
					color: 'transparent',
				},
			},
		},

		Svg: {
			position: 'absolute',
			top: 0,
			right: 0,
			bottom: 0,
			left: 0,
			width: '100%',
			height: '100%',
			minWidth: 0,
			minHeight: 0,
			overflow: 'visible',
			pointerEvents: 'auto',
			transition: 'none',
		},

		Stroke: {
			pointerEvents: 'stroke',
			transition: 'none',
		},

		Line_labeler: {
			flex: {
				grow: 1,
			},
		},
		Line_color_hex: {
			String: {
				width: '7rem',
			},
		},
		Line_width: {
			flex: {
				grow: 0,
			},
		},

	} )

}
